export default {
  headerAttemptsRemaining3: 'Verify your bank account instantly',
  headerAttemptsRemaining2: 'Please try again',
  headerAttemptsRemaining1: 'Final attempt',
  headerAttemptsRemaining0: 'Codes failed',
  messageAttemptsRemaining3:
    "Find the $0.01 deposit in the bank account you're verifying. The code you need is the four characters before or after the dash appearing at the beginning or end of the transaction description. Here are some examples:",
  messageAttemptsRemaining2:
    'The 4-character code you entered is not accurate. You have two more attempts. The code you need is the four characters before or after the dash appearing at the beginning or end of the transaction description. Here are some examples:',
  messageAttemptsRemaining1:
    'The 4-character code you entered is not accurate. You have one more attempt. The code you need is the four characters before or after the dash appearing at the beginning or end of the transaction description. Here are some examples:',
  messageAttemptsRemaining0:
    'The code you entered is not accurate and you are out of attempts.',
  messageSupport: 'Please reach out to {enterprise} for help.',
  codePlaceholder: 'Enter 4-character code',
  yourCode: 'Your code',
  expiredPageHeader: 'Code expired',
  expiredPageMessage:
    'The code you were sent has expired. Request a new one and try again or reach out to {enterprise} for help.',
  errorPageHeader: 'Something went wrong',
  errorPageMessage:
    'Please repeat the instructions in the email we sent. If the problem persists, reach out to {enterprise} for help.',
  formErrorLength: 'Code should be 4 characters long',
  formErrorNoCode: 'Please enter the code on your bank statement',
  poweredBy: 'Powered by',
  continue: 'Continue',
  tryAgain: 'Try again',
  successHeader: 'Success',
  successMessage: 'Your account was verified!',
  checkEmailHeader: 'Check your email',
  checkEmailMessage:
    'Are you looking to verify your bank account? Check your inbox and follow the instructions in the email we sent.',
  checkEmailMessageWithEnterprise:
    'Are you looking to verify your bank account with {enterprise}? Check your inbox and follow the instructions in the email we sent.',
  noEmail: "Don't see an email? Reach out to {enterprise} for help.",
  needHelpLink: 'Need help?',
  needHelpHeader: 'Need help?',
  needHelpMessage:
    'Most verification codes take up to 15 seconds to appear in your bank account but some can take longer. If it has been over a minute, check back at this time on the next business day.',
  done: 'Done',
  dontSeeYourCode: 'Don’t see your code?',
  dontSeeYourCodeMsg:
    'Check your bank account from desktop online banking. Sometimes the code gets cut off when viewed on a mobile device or app.',
  controlCodeExampleImgAltTextEnding:
    'Bank transaction titled ACCTVERIFY-B3M1 for $0.01',
  controlCodeExampleImgAltTextBeginning:
    'Bank transaction titled A4F3-ACCTVERIFY for $0.01',
}
